/**
 * @generated SignedSource<<7307b988261a10124eb1a2f531197c67>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TravelDocumentSelect_data$data = {
  readonly allTravelDocuments: ReadonlyArray<{
    readonly id: string;
    readonly name: string;
  }>;
  readonly " $fragmentType": "TravelDocumentSelect_data";
};
export type TravelDocumentSelect_data$key = {
  readonly " $data"?: TravelDocumentSelect_data$data;
  readonly " $fragmentSpreads": FragmentRefs<"TravelDocumentSelect_data">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TravelDocumentSelect_data",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TravelDocument",
      "kind": "LinkedField",
      "name": "allTravelDocuments",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "46373dce3361b87f7801549500e4601d";

export default node;
